export default __webpack_public_path__ + "static/media/portada.a942045a.jpg";